/**
 * Dependencies
 */
import { getState } from './state'

const TOGGLE_MODAL = state => {
    state.showModal = !state.showModal
}

const SET_PHOTO = (state, data) => {
    state.data = data
}

const RESET_STATE = state => {
    Object.assign(state, getState())
}

const SET_LOADING = state => {
    state.loading = true
}

const RESET_LOADING = state => {
    state.loading = false
}

export default {
    SET_PHOTO,
    SET_LOADING,
    RESET_STATE,
    TOGGLE_MODAL,
    RESET_LOADING
}



// WEBPACK FOOTER //
// ./src/state/modules/dom/image-uploader/mutations.js